<div class="card text-center">
  <div class="title">
    <h2>
      <b>{{ descricao | uppercase }}</b>
    </h2>
  </div>
  <div class="price">
    <span
      style="
        font-size: 14px !important;
        color: #f6f3f3 !important;
        font-weight: 800 !important;
        margin-bottom: 0px;
        margin-top: 5px !important;
      ">
      A partir de
    </span>

    <h4 style="font-size: 3.2em !important; font-weight: 600">
      {{ valor | FormatNumberDecimalPipe }}
      <span style="margin-left: -13px; font-size: 34px">,{{ valor.toFixed(2).split('.')[1] }}</span>
      <!--

            .toFixed(2).split('.')[1] -->
    </h4>
    <div
      class="text-center"
      style="
        font-size: 14px !important;
        margin-left: -26% !important;
        color: #f6f3f3 !important;
        font-weight: 800 !important;
        margin-top: -16px !important;
      ">
      <span class=" " style="margin-left: 11rem !important">Por mês</span>
    </div>
  </div>
  <hr />
  <div class="option">
    <ul>
      <li>
        <i class="fa fa-check" aria-hidden="true"></i>
        ABRANGÊNCIA: {{ abrangencia | uppercase }}
      </li>
      <li *ngIf="ehSaude">
        <i class="fa fa-check" aria-hidden="true"></i>
        ACOMODAÇÃO: {{ acomodacao | uppercase }}
      </li>
      <li>
        <i class="fa fa-check" aria-hidden="true"></i>
        ANS:
        <b>{{ numeroRegistro | uppercase }}</b>
      </li>
      <li>
        <i class="fa fa-times" aria-hidden="true"></i>
        COPARTICIPAÇÃO:
        <b>NÃO</b>
      </li>
    </ul>
  </div>
  <button
    (click)="onComprar()"
    style="cursor: pointer !important"
    type="button"
    class="btn cursor-pointer box-shadow-5 round btn-min-width">
    <b style="color: #023341">COMPRE ONLINE</b>
  </button>
</div>
